import { render, staticRenderFns } from "./FreeBetCard.vue?vue&type=template&id=3134d874&scoped=true"
import script from "./FreeBetCard.vue?vue&type=script&lang=js"
export * from "./FreeBetCard.vue?vue&type=script&lang=js"
import style0 from "./FreeBetCard.vue?vue&type=style&index=0&id=3134d874&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3134d874",
  null
  
)

export default component.exports